import { createBrowserRouter } from 'react-router'
import { routes } from '@/routes/routes'

export const router = createBrowserRouter(routes)
